import { useSearchParams } from 'react-router-dom';
import { REGISTER_ID_SEARCH_PARAM_KEY } from '@/modules/common/constants/search-params.ts';

export const useGetRegisterIdParam = () => {
  const [params] = useSearchParams();
  return params.get(REGISTER_ID_SEARCH_PARAM_KEY);
};
